import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { ContactDetailsHelperService } from "../../../services/PlacardEditionServices/upplm.contactDetailsHelper.service";
import { StoredDataService } from "../../../services/upplm.storedData.service";
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ContactDetailsSession } from "../../../api/models/contactDetailsSession";
import { UpsDialogComponent } from "../../commonComponent/ups-dialog/ups-dialog.component";
import { TranslateDataPipe } from "../../../pipes/translation.pipe";

@Component({
    selector: 'editcontactdetails',
    template: require('./editContactDetails.component.html'),
    providers: [ContactDetailsHelperService]
})

export class EditContactDetailsComponent implements OnInit {

    showEditContactDetails: boolean = true;
    contactForm: FormGroup;
    primaryContactForm: FormGroup;
    errors: any[];
    iAmPrimaryContact: boolean = true;
    isLoading: boolean = false;
    showNotificationChanges: boolean = false;
    @ViewChild('errorServerMessage', { static: false }) errorServerMessage: UpsDialogComponent;

    @Output() hideEditSection = new EventEmitter<boolean>();

    constructor(
        private _storedDataService: StoredDataService,
        private _contactDetailsHelperService: ContactDetailsHelperService,
        private _formBuilder: FormBuilder,
        private _translatePipe: TranslateDataPipe
    ) { }

    ngOnInit(): void {

        this.contactForm = this._formBuilder.group({
            contactName: new FormControl('', Validators.required),
            contactEmail: new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
            phoneNumber: new FormControl('', [Validators.required, this.validatePhone]),
            extension: new FormControl('')
        });

        this.primaryContactForm = this._formBuilder.group({
            primaryContactName: new FormControl('', Validators.required),
            primaryContactEmail: new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
            primaryPhoneNumber: new FormControl('', [Validators.required, this.validatePhone]),
            primaryExtension: new FormControl('')
        });

        this.bindDataFromStoredData(this._storedDataService.contactDetails);
    }

    bindDataFromStoredData(data: ContactDetailsSession) {

        this.contactForm.setValue({
            contactName: data.name,
            contactEmail: data.email,
            phoneNumber: data.phone,
            extension: data.ext
        });

        this.iAmPrimaryContact = data.makePrimaryContact;

        if (!this.iAmPrimaryContact) {
            this.primaryContactForm.setValue({
                primaryContactName: data.primaryName,
                primaryContactEmail: data.primaryEmail,
                primaryPhoneNumber: data.primaryPhone,
                primaryExtension: data.primaryExt
            });
        }

    }

    saveEdit() {
        this.isLoading = true;
        this.displayErrors();

        if (this.errors.length == 0) {
            this.saveEditedDataToRequest();
            this.showNotificationsControl(true);
        }
        this.isLoading = false;
    }

    cancel() {
        this._storedDataService.clearEditingSections();
        this.hideEditSection.emit(true);
    }

    validatePhone(control: AbstractControl): { [key: string]: boolean } | null {

        let value = control.value.toString().trim().replace(/^\+/, '');
        let valueChar = value.charAt(0) === '-' ? true : false;
        let valueMatch = value.match(/\d+$/) && !valueChar ? true : false;

        if (control.value != '' && !valueMatch) {
            return { 'valid': false };
        }

        return null;
    }

    displayErrors() {
        this.errors = [];

        if (this.contactForm.controls.contactName.value == "") {
            this.errors = this.errors.concat(this.addError('contactName', this._translatePipe.transform('upplm.contactdetails.nameisrequired'), 'required'));
        }

        if (this.contactForm.controls.phoneNumber.value == '') {
            this.errors = this.errors.concat(this.addError('phoneNumber', this._translatePipe.transform('upplm.contactdetails.phoneisrequired'), 'required'));
        }
        else if (this.contactForm.controls.phoneNumber.invalid) {
            this.errors = this.errors.concat(this.addError('phoneNumber', this._translatePipe.transform('upplm.contactdetails.phoneisinvalid'), 'invalidFormat'));
        }

        if (this.contactForm.controls.contactEmail.value == '') {
            this.errors = this.errors.concat(this.addError('contactEmail', this._translatePipe.transform('upplm.contactdetails.emailisrequired'), 'required'));
        }
        else if (this.contactForm.controls.contactEmail.invalid) {
            this.errors = this.errors.concat(this.addError('contactEmail', this._translatePipe.transform('upplm.contactdetails.emailisinvalid'), 'invalidFormat'));
        }

        if (!this.iAmPrimaryContact) {
            if (this.primaryContactForm.controls.primaryContactName.value == "") {
                this.errors = this.errors.concat(this.addError('primaryContactName', this._translatePipe.transform('upplm.contactdetails.primarycontactnameisrequired'), 'required'));
                this.primaryContactForm.controls.primaryContactName.markAsTouched();
            }

            if (this.primaryContactForm.controls.primaryPhoneNumber.value == '') {
                this.errors = this.errors.concat(this.addError('primaryPhoneNumber', this._translatePipe.transform('upplm.contactdetails.primaryphoneisrequired'), 'required'));
                this.primaryContactForm.controls.primaryPhoneNumber.markAsTouched();
            }
            else if (this.primaryContactForm.controls.primaryPhoneNumber.invalid) {
                this.errors = this.errors.concat(this.addError('primaryPhoneNumber', this._translatePipe.transform('upplm.contactdetails.primaryphoneisinvalid'), 'invalidFormat'));
                this.primaryContactForm.controls.primaryPhoneNumber.markAsTouched();
            }

            if (this.primaryContactForm.controls.primaryContactEmail.value == '') {
                this.errors = this.errors.concat(this.addError('primaryContactEmail', this._translatePipe.transform('upplm.contactdetails.primaryemailisrequired'), 'required'));
                this.primaryContactForm.controls.primaryContactEmail.markAsTouched();
            }
            else if (this.primaryContactForm.controls.primaryContactEmail.invalid) {
                this.errors = this.errors.concat(this.addError('primaryContactEmail', this._translatePipe.transform('upplm.contactdetails.primaryemailisinvalid'), 'invalidFormat'));
                this.primaryContactForm.controls.primaryContactEmail.markAsTouched();
            }
        }
    }

    addError(id: string, field: string, condition: string): any {
        return [{
            "id": id,
            "displayText": field,
            "type": condition,
            "fieldName": "Name",
            "fieldError": "Name error",
            "fieldErrorDescription": "field Error"
        }];
    }

    focusInput(item: any) {
        document.getElementById(item.id).focus();
    }

    saveEditedDataToRequest() {
        this._storedDataService.requestEditedData = this._contactDetailsHelperService.prepareSaveEditionRequest(this.buildObjectForPrepareRequest());
    }

    buildObjectForPrepareRequest(): ContactDetailsSession {

        let contact = this.contactForm.getRawValue();
        let primaryContact = this.primaryContactForm.getRawValue();

        return {
            name: contact.contactName,
            email: contact.contactEmail,
            phone: contact.phoneNumber,
            ext: contact.extension,
            makePrimaryContact: this.iAmPrimaryContact,
            primaryName: this.iAmPrimaryContact ? contact.contactName : primaryContact.primaryContactName,
            primaryEmail: this.iAmPrimaryContact ? contact.contactEmail : primaryContact.primaryContactEmail,
            primaryPhone: this.iAmPrimaryContact ? contact.phoneNumber : primaryContact.primaryPhoneNumber,
            primaryExt: this.iAmPrimaryContact ? contact.extension : primaryContact.primaryExtension
        } as ContactDetailsSession;
    }

    showNotificationsControl(show: boolean) {
        this.showEditContactDetails = !show;
        this.showNotificationChanges = show;
    }

    hideNotificationChange(showNotificationControl: boolean) {

        this.showNotificationsControl(showNotificationControl);

        if (this._storedDataService.isEditionComplete) {
            this.cancel();
        }
    }
}